import admin from "@/router/admin";
import qss from "@/router/qss";
import sportcenter from "@/router/sportcenter";
import province from "@/router/province";
export default [...admin, ...qss, ...sportcenter, ...province];
